import { Module } from 'vuex'
import { blankResponseArray } from '../constants'
import { RootState } from '../types'
import { actions } from './actions'
import { blankInquiry, blankSearchFilters } from './constants'
import { getters } from './getters'
import { mutations } from './mutations'
import State from './types'
import _ from 'lodash'

export const state: State = {
  error: false,
  activeInquiry: _.cloneDeep(blankInquiry),
  page: 1,
  pageSize: 8,
  inquiries: blankResponseArray,
  customers: blankResponseArray,
  preloaded: false,
  isSubmittingInquiry: false,
  submissionError: '',
  currentInquiry: _.cloneDeep(blankInquiry),
  validationErrors: {},
  searchFilters: _.cloneDeep(blankSearchFilters),
  documentsLoading: false,
  inquiryDocuments: [],
  inquiryChanged: false,
  currentCustomer: '',
  rememberedInquiryListTab: 'Open',
  inquiryEditorOpenOnItemsTab: false,
}

const namespaced = true

export const inquiries: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
